/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archival_Add_PlayerInputs */



/**
* | output |
* | --- |
* | "Add a player" |
*
* @param {Archival_Add_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archival_add_player = /** @type {((inputs?: Archival_Add_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archival_Add_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un joueur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir un jugador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicionar um jogador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi un giocatore")
	return /** @type {LocalizedString} */ ("Add a player")
});